import React from 'react';

export function CouponsPagination({
  rowsPerPage,
  rowCount,
  currentPage,
  onChangePage,
  onChangeRowsPerPage,
  paginationRowsPerPageOptions = [10, 15, 20, 25, 30],
}) {
  const numPages = Math.ceil(rowCount / rowsPerPage) || 1;
  const lastIndex = currentPage * rowsPerPage;
  const firstIndex = rowCount === 0 ? 0 : lastIndex - rowsPerPage + 1;
  const disabledPrevious = currentPage === 1;
  const disabledNext = currentPage === numPages;
  const range =
    currentPage === numPages
      ? `${firstIndex}-${rowCount} de ${rowCount}`
      : `${firstIndex}-${lastIndex} de ${rowCount}`;

  return (
    <nav
      className="rdt_Pagination"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '8px 16px',
        borderTop: '1px solid #ebedf3',
        fontSize: '13px',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '100%',
        letterSpacing: '0%',
        color: '#838486',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>Linhas por página</span>
        <select
          className="form-control form-control-sm"
          value={rowsPerPage}
          onChange={(e) =>
            onChangeRowsPerPage(Number(e.target.value), currentPage)
          }
          label="Linhas por página "
          aria-label="Linhas por página"
          style={{ margin: '0 12px', width: 'auto' }}
        >
          {paginationRowsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <span>{range}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          className="btn btn-clean btn-icon btn-sm"
          disabled={disabledPrevious}
          onClick={() => onChangePage(1)}
          aria-label="Primeira página"
        >
          <i className="ki ki-double-arrow-back" />
        </button>
        <button
          type="button"
          className="btn btn-clean btn-icon btn-sm"
          disabled={disabledPrevious}
          onClick={() => onChangePage(currentPage - 1)}
          aria-label="Página anterior"
        >
          <i className="ki ki-arrow-back" />
        </button>
        <button
          type="button"
          className="btn btn-clean btn-icon btn-sm"
          disabled={disabledNext}
          onClick={() => onChangePage(currentPage + 1)}
          aria-label="Próxima página"
        >
          <i className="ki ki-arrow-next" />
        </button>
        <button
          type="button"
          className="btn btn-clean btn-icon btn-sm"
          disabled={disabledNext}
          onClick={() => onChangePage(numPages)}
          aria-label="Última página"
        >
          <i className="ki ki-double-arrow-next" />
        </button>
      </div>
    </nav>
  );
}
